import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Toast = ({ type = "success", message, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onClose, 300);
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor =
    type === "error" ? "bg-red-500 text-white" : "bg-green-500 text-white";
  const borderColor = type === "error" ? "border-red-700" : "border-green-700";

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ x: 100, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 100, opacity: 0 }}
          transition={{
            type: "spring",
            stiffness: 300,
            damping: 20,
            duration: 0.5,
          }}
          className={`w-80 p-4 border-l-4 ${borderColor} ${bgColor} shadow-lg rounded-md flex justify-between items-center z-50 fixed top-5 right-5`}
        >
          <div>
            <p className="font-semibold">
              {type === "error" ? "Error" : "Success"}
            </p>
            <p className="text-sm">{message}</p>
          </div>
          <button className="text-white font-bold text-lg" onClick={onClose}>
            &times;
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;
